import { get, post } from "../GenericServices";

const CostEstimation = {
  projectEstimateWorkPackageTableSummary: (id, year) => {
    return get(`project-estimate/${id}/cost-estimation/summary/${year}`);
  },
  projectEstimateWorkPackageTableTotalSummary: (id, year) => {
    return get(`project-estimate/${id}/cost-estimation/summary/${year}/total`);
  },
  projectEstimateWorkPackageTableDownloadSummary: (id, year) => {
    return get(`project-estimate/${id}/cost-estimation/summary/${year}/report`);
  },
  projectEstimateWorkPackageTableSummaryWbs: (id, wbsId, year) => {
    return get(`project-estimate/${id}/cost-estimation/summary/${year}/wbs/${wbsId}`);
  },

  projectEstimateWorkPackageTableSummaryWip: (id, year) => {
    return get(`project-estimate/${id}/cost-estimation/summary-wip/${year}`);
  },
  projectEstimateWorkPackageTableTotalSummaryWip: (id, year) => {
    return get(`project-estimate/${id}/cost-estimation/summary-wip/${year}/total`);
  },
  projectEstimateWorkPackageTableSummaryWipWbs: (id, wbsId, year) => {
    return get(`project-estimate/${id}/cost-estimation/summary-wip/${year}/wbs/${wbsId}`);
  },

  projectEstimateWorkPackageTableWP: (projectId, WpId, year) => {
    return get(`project-estimate/${projectId}/cost-estimation/work-package/${WpId}/${year}`);
  },
  projectEstimateWorkPackageTableTotalWP: (projectId, WpId, year) => {
    return get(`project-estimate/${projectId}/cost-estimation/work-package/${WpId}/${year}/total`);
  },
  projectEstimateWorkPackageTableWPWbs: (projectId, WpId, wbsId, year) => {
    return get(`project-estimate/${projectId}/cost-estimation/work-package/${WpId}/${year}/wbs/${wbsId}`);
  },
  projectEstimateWorkPackageTableWPWbsSave: (projectId, WpId, wbsId, queryString) => {
    return post(`project-estimate/${projectId}/cost-estimation/work-package/${WpId}/wbs/${wbsId}?${queryString}`);
  },
  projectEstimateWorkPackageCopy: (projectId, wp, copyWp) => {
    return post(`project-estimate/${projectId}/cost-estimation/work-package/${wp}/copy?workPackageIdToCopy=${copyWp}`);
  },
  projectEstimateWorkPackageTableDownloadWP: (projectId, WpId, year) => {
    return get(`project-estimate/${projectId}/cost-estimation/work-package/${WpId}/${year}/report`);
  },
  saveProjectEstimateWp: (projectEstimateId, wpId, year, body) => {
    return post(`project-estimate/${projectEstimateId}/cost-estimation/work-package/${wpId}/${year}`, body);
  },
  costEstimationSummaryVop: (projectEstimateId, year) => {
    return get(`project-estimate/${projectEstimateId}/cost-estimation/summary/${year}/vop`);
  },
  costEstimationSummaryWipVop: (projectEstimateId, year) => {
    return get(`project-estimate/${projectEstimateId}/cost-estimation/summary-wip/${year}/vop`);
  },
  costEstimationWorkPackageVop: (projectEstimateId, wpId, year) => {
    return get(`project-estimate/${projectEstimateId}/cost-estimation/work-package/${wpId}/${year}/vop`);
  },
};

export default CostEstimation;
